const OVERRIDE_STYLE_ID = "rio-assist-host-overrides";

let cleanupWidgetUiOverrides: (() => void) | null = null;

export const cleanupWidgetUiOverridesIfAny = () => {
  if (cleanupWidgetUiOverrides) {
    cleanupWidgetUiOverrides();
    cleanupWidgetUiOverrides = null;
  }
};

export const applyWidgetUiOverrides = (host: HTMLElement) => {
  cleanupWidgetUiOverridesIfAny();

  let observer: MutationObserver | null = null;

  const applyOverrides = () => {
    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) {
      return false;
    }

    const floatingButton = shadowRoot.querySelector<HTMLElement>(".floating-button");
    if (floatingButton && !floatingButton.dataset.dragGuard) {
      floatingButton.dataset.dragGuard = "true";
      floatingButton.addEventListener("dragstart", (event) => event.preventDefault());
    }
    for (const image of floatingButton?.querySelectorAll("img") ?? []) {
      if (image.draggable) {
        image.draggable = false;
      }
    }

    let overrideStyle = shadowRoot.querySelector(`#${OVERRIDE_STYLE_ID}`);
    if (!overrideStyle) {
      overrideStyle = document.createElement("style");
      overrideStyle.id = OVERRIDE_STYLE_ID;
      overrideStyle.textContent = `
        .consultant-agent__button {
          display: none !important;
        }
      `;
      shadowRoot.appendChild(overrideStyle);
    }

    return Boolean(floatingButton);
  };

  const startObserver = () => {
    if (!host.shadowRoot || observer) {
      return;
    }

    observer = new MutationObserver(() => {
      applyOverrides();
    });
    observer.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true });
  };

  const attached = applyOverrides();
  startObserver();

  if (!attached) {
    let attempts = 0;
    const intervalId = globalThis.setInterval(() => {
      attempts += 1;
      applyOverrides();
      startObserver();
      if (observer || attempts >= 20) {
        globalThis.clearInterval(intervalId);
      }
    }, 150);

    cleanupWidgetUiOverrides = () => {
      globalThis.clearInterval(intervalId);
      observer?.disconnect();
      cleanupWidgetUiOverrides = null;
    };
    return;
  }

  cleanupWidgetUiOverrides = () => {
    observer?.disconnect();
    cleanupWidgetUiOverrides = null;
  };
};
